import { Radio } from 'antd'
import React, { useState } from 'react'
import DoctorSelfEnrollment from '../Pages/Enrollment/doctor';
import PatientReg from '../Pages/Enrollment/patientReg';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateSelectedOption } from '../Redux/actions/commonActions';

function SignUp({handleRegClose}) {
    const {selectedType} = useSelector((state) => state.common);
    const dispatch = useDispatch();

    const handleRadioSelect = (e) => {
        const selectedOption = e.target.value;
        dispatch(UpdateSelectedOption(selectedOption));
    };

    return (
        <div>
            <div className="m-6">
                <Radio.Group onChange={handleRadioSelect} value={selectedType}>
                    <Radio className="font-medium" value="doctor">
                        Doctor
                    </Radio>
                    <Radio className="font-medium" value="patient">
                        Patient
                    </Radio>
                </Radio.Group>
            </div>
            {selectedType === "doctor" ? (
                <DoctorSelfEnrollment handleDoctorClose={handleRegClose} />
            ) : (
                // <div className='flex justify-center items-center'>
                //   <img src={InProgress} alt='In Progress'/>
                // </div>
                <PatientReg handleCancel={handleRegClose} />
            )}
        </div>
    )
}

export default SignUp